import "./Privacy.css";

function TermsAndConditions() {
  return (
    <div className="privacy-container">
      <h1>Terms and Conditions for LunaPlane</h1>
      <p className="effective-date">Effective Date: April 15, 2026</p>

      <p>
        Welcome to LunaPlane, a platform offering personal enrichment services
        designed to help you connect with guides, wellness practitioners, and
        companions who support your personal growth and well-being. By using
        LunaPlane, you agree to these Terms and Conditions.
      </p>

      <div className="privacy-section">
        <h3>1. Acceptance of Terms</h3>
        <p>
          By creating an account or using LunaPlane, you agree to comply with
          these Terms, our Privacy Policy, and all applicable laws. If you do
          not agree, please discontinue use.
        </p>
      </div>

      <div className="privacy-section">
        <h3>2. Eligibility</h3>
        <p>You must:</p>
        <div className="privacy-list">
          <p>Be at least 18 years old (or the age of majority in your jurisdiction).</p>
          <p>Provide accurate and truthful information during registration.</p>
          <p>
            Use LunaPlane solely for personal enrichment purposes—this includes
            connecting with wellness guides, tour guides, and companions.
          </p>
        </div>
      </div>

      <div className="privacy-section">
        <h3>3. Account Responsibilities</h3>
        <div className="privacy-list">
          <p>You are responsible for maintaining the security of your account.</p>
          <p>Notify us immediately if you suspect unauthorized access.</p>
          <p>
            You agree not to share your login credentials or use another person’s account.
          </p>
        </div>
      </div>

      <div className="privacy-section">
        <h3>4. Prohibited Activities</h3>
        <p>You must not:</p>
        <div className="privacy-list">
          <p>Engage in illegal or fraudulent activities.</p>
          <p>Post explicit, pornographic, or adult content.</p>
          <p>Solicit or offer sexual services or payments for sex in any form.</p>
          <p>Harass, bully, or exploit other users.</p>
          <p>Fake your identity or location.</p>
        </div>
        <p>
          Violations may result in immediate account suspension or termination.
        </p>
      </div>

      <div className="privacy-section">
        <h3>5. Personal Enrichment Services Disclaimer</h3>
        <p>
          LunaPlane is a platform to connect you with licensed or vetted
          professionals (e.g., wellness guides, tour guides, companions). We do
          not provide medical, legal, or financial advice. Always seek
          professional help for those needs.
        </p>
      </div>

      <div className="privacy-section">
        <h3>6. Payments and Bookings</h3>
        <p>
          All payments are processed securely through third-party providers. You
          agree to pay for services booked. Refunds or cancellations follow the
          provider’s policies.
        </p>
      </div>

      <div className="privacy-section">
        <h3>7. Privacy Policy</h3>
        <p>
          We collect only necessary personal data (e.g., name, contact info,
          booking details) to facilitate services. For full details, refer to
          our Privacy Policy.
        </p>
      </div>

      <div className="privacy-section">
        <h3>8. Community Conduct</h3>
        <p>You agree to treat other users with respect. Do not:</p>
        <div className="privacy-list">
          <p>Harass or bully.</p>
          <p>Share false or harmful information.</p>
          <p>Exploit or scam others.</p>
        </div>
      </div>

      <div className="privacy-section">
        <h3>9. Third-Party Services</h3>
        <p>
          LunaPlane may link to third-party tools (e.g., payments, analytics).
          We are not responsible for third-party actions.
        </p>
      </div>

      <div className="privacy-section">
        <h3>10. Updates to Terms</h3>
        <p>
          We may update these Terms periodically. Continued use means you accept
          the revised Terms.
        </p>
      </div>

      <div className="privacy-section">
        <h3>11. Termination</h3>
        <p>
          We reserve the right to suspend or terminate your account if you
          violate these Terms or compromise safety.
        </p>
      </div>

      <div className="privacy-section">
        <h3>12. Limitation of Liability</h3>
        <p>
          LunaPlane is provided <span>"as is."</span> We are not liable for user
          actions, service outcomes, or third-party integrations. Use at your
          own risk.
        </p>
      </div>

      <div className="privacy-section">
        <h3>13. Governing Law</h3>
        <p>
          These Terms are governed by International laws <span>.</span>.
        </p>
      </div>

      <div className="privacy-section">
        <h3>14. Contact Us</h3>
        <p>
          Email:{" "}
          <a href="mailto:info@lunaplane.com">
            info@lunaplane.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default TermsAndConditions;